import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import FileListAnswer from '@/components/shared/answer-types/file-list/file-list.vue';
import { YES_NO_OPTIONS, MAX_FILE_UPLOADS, MAX_FILE_SIZE_MB, DEFAULTS } from '../../constants/club-registration-constants.js';

export default {
    name: 'DocumentsSettingsSection',

    components: {
        'text-answer': TextAnswer,
        'checkbox-answer': CheckBoxAnswer,
        'file-list-answer': FileListAnswer
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        previewApi: {
            type: Function,
            default: null
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            maxFileUploads: MAX_FILE_UPLOADS,
            maxFileSizeMb: MAX_FILE_SIZE_MB,
            yesNoOptions: YES_NO_OPTIONS
        };
    },

    computed: {
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/documents-settings-section/documents-settings-section.js